import React, { useState } from 'react';
import { writeText } from '../utils/clipboard';

/**
 * A reusable input field with copy-to-clipboard functionality
 * @param {Object} props
 * @param {string} props.value - The value to display and copy
 * @param {string} props.label - Optional label for the input
 * @param {React.ReactNode} props.icon - Optional icon to show before the label
 * @param {string} props.copyText - Text to show on copy button (default: "Copy")
 * @param {string} props.copiedText - Text to show after copying (default: "Copied")
 * @param {string} props.className - Additional class names for the wrapper
 * @param {string} props.inputClassName - Additional class names for the input
 */
export const CopyableInput = ({
  value,
  label,
  icon,
  copyText = 'Copy',
  copiedText = 'Copied',
  className = '',
  inputClassName = 'form-control bg-light'
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <div className={className}>
      {label && (
        <label className="form-label fw-semibold d-flex align-items-center gap-2">
          {icon}
          {label}
        </label>
      )}
      <div className="input-group flex-nowrap">
        <input
          type="text"
          className={inputClassName}
          value={value}
          readOnly
          style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
        />
        <button
          className="btn btn-outline-secondary d-flex align-items-center gap-1"
          type="button"
          onClick={handleCopy}
          style={{ flexShrink: 0, width: 'auto' }}
        >
          <i className={`bi ${copied ? 'bi-check-lg text-success' : 'bi-clipboard'}`}></i>
          <span className="d-none d-sm-inline">{copied ? copiedText : copyText}</span>
        </button>
      </div>
    </div>
  );
};

export default CopyableInput;
